function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n3 = 0, F = function F() {}; return { s: F, n: function n() { return _n3 >= r.length ? { done: !0 } : { done: !1, value: r[_n3++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/*! License details at fancyapps.com/license */
import { isPlainObject as n } from "../utils/isPlainObject.js";
var e = {
    syncOnChange: !1,
    syncOnClick: !0,
    syncOnHover: !1
  },
  i = function i() {
    var i, t;
    function o() {
      var t = null == i ? void 0 : i.getOptions().Sync;
      return n(t) ? Object.assign(Object.assign({}, e), t) : e;
    }
    function s(n) {
      var e, s, l;
      i && n && (t = n, i.getOptions().classes = Object.assign(Object.assign({}, i.getOptions().classes), {
        isSelected: ""
      }), i.getOptions().initialSlide = (null === (s = null === (e = t.getPage()) || void 0 === e ? void 0 : e.slides[0]) || void 0 === s ? void 0 : s.index) || 0, o().syncOnChange && i.on("change", c), o().syncOnClick && i.on("click", g), o().syncOnHover && (null === (l = i.getViewport()) || void 0 === l || l.addEventListener("mouseover", u)), function () {
        if (!i || !t) return;
        i.on("ready", d), i.on("refresh", a), t.on("change", r), t.on("filter", f);
      }());
    }
    function l() {
      var n = o().target;
      i && n && s(n);
    }
    function d() {
      v();
    }
    function c() {
      var n;
      if (i && t) {
        var _e = (null === (n = i.getPage()) || void 0 === n ? void 0 : n.slides) || [],
          _o = t.getPageIndex(_e[0].index || 0);
        _o > -1 && t.goTo(_o, i.hasNavigated() ? void 0 : {
          tween: !1,
          transition: !1
        }), v();
      }
    }
    function r() {
      var n;
      if (i && t) {
        var _e2 = i.getPageIndex((null === (n = t.getPage()) || void 0 === n ? void 0 : n.slides[0].index) || 0);
        _e2 > -1 && i.goTo(_e2, t.hasNavigated() ? void 0 : {
          tween: !1,
          transition: !1
        }), v();
      }
    }
    function g(n, e) {
      var o;
      if (!i || !t) return;
      if (null === (o = i.getTween()) || void 0 === o ? void 0 : o.isRunning()) return;
      var s = null == i ? void 0 : i.getOptions().classes.slide;
      if (!s) return;
      var l = s ? e.target.closest(".".concat(s)) : null;
      if (l) {
        var _n = parseInt(l.getAttribute("index") || "") || 0,
          _e3 = t.getPageIndex(_n);
        t.goTo(_e3);
      }
    }
    function u(n) {
      i && g(0, n);
    }
    function a() {
      var n;
      if (i && t) {
        var _e4 = i.getPageIndex((null === (n = t.getPage()) || void 0 === n ? void 0 : n.slides[0].index) || 0);
        _e4 > -1 && i.goTo(_e4, {
          tween: !1,
          transition: !1
        }), v();
      }
    }
    function f(n, e) {
      i && t && (i.filter(e), r());
    }
    function v() {
      var n, e, o;
      if (!t) return;
      var s = (null === (e = null === (n = t.getPage()) || void 0 === n ? void 0 : n.slides[0]) || void 0 === e ? void 0 : e.index) || 0;
      var _iterator = _createForOfIteratorHelper((null == i ? void 0 : i.getSlides()) || []),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _n2 = _step.value;
          null === (o = _n2.el) || void 0 === o || o.classList.toggle("is-selected", _n2.index === s);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return {
      init: function init(n) {
        i = n, i.on("initSlides", l);
      },
      destroy: function destroy() {
        var n;
        null == i || i.off("ready", d), null == i || i.off("refresh", a), null == i || i.off("change", c), null == i || i.off("click", g), null === (n = null == i ? void 0 : i.getViewport()) || void 0 === n || n.removeEventListener("mouseover", u), null == t || t.off("change", r), null == t || t.off("filter", f), t = void 0, null == i || i.off("initSlides", l), i = void 0;
      },
      getTarget: function getTarget() {
        return t;
      }
    };
  };
export { i as Sync };